<template lang="pug">
#header-container
    #header.fixed-top(:style='aplicarZindex()')
        #logo-wrapper(v-if='logoUrlDefault')
            img#logo-lyra(src='@/assets/lyra-logo.svg')

        #logo-wrapper-bunge(v-else, :class='{ "logo-be8": logoBe8 }')
            img#logo-bunge(:src='logoUrlCustom')

        #language-dropdown
            .language-name.link-suporte(@click='openSupport')
                i.mdi.mdi-face-agent.link-suporte__support
                span Suporte
            el-dropdown.el-dropdown-div
                span.el-dropdown-link
                    span.language-name {{ selectedLanguageName }}
                    i.icon-arrow-lang.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot='dropdown')
                    el-dropdown-item(@click.native='switchLanguage("pt-BR")') Português
                        span.language-code (pt-br)
                    el-dropdown-item(@click.native='switchLanguage("en")') English
                        span.language-code (en)
                    el-dropdown-item(@click.native='switchLanguage("es")') Español
                        span.language-code (es)

        #user-logged
            el-dropdown
                span.el-dropdown-link
                    div
                        i.user-logo.mdi.mdi-account-circle
                    span.dados_user
                        .username {{ user.nome }}
                        .empresa-selecionada-container(
                            v-if='user.ambienteLogado !== ""'
                        )
                            .empresa-selecionada.sl-flag(
                                :class='user.ambienteLogado === ambientes.PARAGUAY ? "flag-paraguai" : user.ambienteLogado === ambientes.ARGENTINA ? "flag-argentina" : "flag-pt-BR"'
                            )
                    i.icon-arrow-user.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot='dropdown')
                    el-dropdown-item {{ user.perfil }}
                    el-dropdown-item(
                        v-if='verificarEmpresas',
                        @click.native='trocarPerfil'
                    )
                        | {{ $t('mensagens.comuns.trocarPerfil') }}
                    el-dropdown-item.sair(
                        divided='',
                        @click.native='logout',
                        icon='el-icon-arrow-left'
                    )
                        | {{ $t('mensagens.comuns.sair') }}

    ModalAmbiente(
        :show='isModalAmbiente',
        :usuario='empresas',
        @close='closeModalAmbiente',
        @alterarAmbiente='alterarAmbiente',
        style='z-index: 4001'
    )
</template>

<script>
import { CULTURAS } from '@/utils/TipoCultura';
import keycloakUtil from '@/utils/keycloak';
import { mapGetters, mapState, mapActions } from 'vuex';

import authService from '@/services/AuthService';
import userService from '@/services/UsuarioService';
import store from '@/store';

import locale from 'element-ui/lib/locale';
import langPt from 'element-ui/lib/locale/lang/pt-br';
import langEn from 'element-ui/lib/locale/lang/en';
import langEs from 'element-ui/lib/locale/lang/es';

import ModalAmbiente from '@/components/layout/ModalAmbiente.vue';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'MenuSuperior',

    components: {
        ModalAmbiente
    },

    data() {
        return {
            CULTURAS,
            user: {
                nome: '',
                nameGroup: '',
                perfil: '',
                locale: '',
                id: '',
                ambienteLogado: ''
            },
            empresas: {
                isBrasil: true,
                isParaguay: true,
                isArgentina: null
            },
            ambientes: AmbientesEmpresas,
            logoUrlDefault: false,
            logoUrlCustom: null,
            selectedLanguageName: '',
            isModalAmbiente: false
        };
    },

    props: {
        route: {
            type: String
        },
        routeParams: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters({
            culturaSelecionada: 'culturaSelecionada',
            abaSelecionadaAreaMonitorada: 'abaSelecionadaAreaMonitorada'
        }),
        verificarEmpresas() {
            const Empresas = Object.values(this.empresas);
            const quantidade = Empresas.filter(
                empresa => empresa === true
            ).length;
            return quantidade >= 0;
        },
        logoBe8() {
            const nameGroup = this.usuarioLogado?.nameGroup?.toUpperCase();

            return nameGroup === 'BE8';
        }
    },

    mounted() {
        this.loadUserData();
    },

    methods: {
        ...mapActions(['limparCamadasPermitidasPorUsuario']),
        changeLocaleElementUI(i18nLocale) {
            switch (i18nLocale) {
                case 'en':
                    locale.use(langEn);
                    break;
                case 'pt-BR':
                    locale.use(langPt);
                    break;
                case 'es':
                    locale.use(langEs);
                    break;
                default:
                    locale.use(langPt);
            }
        },

        aplicarZindex() {
            if (this.$route.name === 'operacaoDashboard') {
                return { 'z-index': '3001' };
            }
        },

        goToInicio() {
            this.$store.commit('SET_CULTURA_SELECIONADA', null);
            this.$store.dispatch('limparFiltro');
            if (this.$route.name !== 'Inicio') {
                this.$router.push({ name: 'Inicio' });
            } else {
                this.$router.go();
            }
        },

        switchLanguage(lang) {
            const languageNames = {
                'pt-BR': 'Português',
                en: 'English',
                es: 'Español'
            };

            this.selectedLanguageName = languageNames[lang];
            const refreshToken = sessionStorage.getItem('refreshToken');

            if (this.user && this.user.id) {
                userService
                    .updateUserLocale(lang, refreshToken)
                    .then(({ data }) => {
                        this.$i18n.locale = lang;
                        sessionStorage.setItem('jwtToken', data.jwtToken);
                        sessionStorage.setItem(
                            'refreshToken',
                            data.refreshToken
                        );
                    });
            }

            this.changeLocaleElementUI(this.$i18n.locale);
            document.documentElement.lang = lang;
        },

        logout() {
            window.location.href = keycloakUtil.getLogoutUrl();
            store.dispatch('clearMarcarExportar_PDF', null);
            store.dispatch('setUsuarioLogado', null);
        },

        trocarPerfil() {
            this.isModalAmbiente = true;
        },

        closeModalAmbiente() {
            this.isModalAmbiente = false;
        },

        alterarAmbiente(novoAmbiente) {
            if (this.user.ambienteLogado === novoAmbiente) return;
            this.updateAmbienteSelecionado(novoAmbiente);
            this.closeModalAmbiente();
        },

        async updateAmbienteSelecionado(novoAmbiente) {
            const refreshToken = sessionStorage.getItem('refreshToken');

            await userService
                .updateAmbienteSelecionado(novoAmbiente, refreshToken)
                .then(({ data }) => {
                    this.user.ambienteLogado = novoAmbiente;
                    sessionStorage.setItem('jwtToken', data.access_token);
                    sessionStorage.setItem('refreshToken', data.refresh_token);
                    store.dispatch('updateUsuarioLogadoAmbiente', novoAmbiente);
                    this.$emit('updateAmbienteSelecionado');

                    if (this.$route.name === 'Home') {
                        window.location.reload();
                    } else {
                        this.$router.push({ name: 'Home' });
                    }

                    this.limparCamadasPermitidasPorUsuario();
                });
        },

        loadUserData() {
            authService
                .isLogged()
                .then(({ data }) => {
                    this.user.nome = data.nome;
                    this.user.locale = data.locale;
                    this.user.id = data.idKeyCloack;
                    this.user.nameGroup =
                        this.$t('mensagens.menuSuperior.grupo') +
                        data.nameGroup
                            .toLowerCase()
                            .split('')
                            .reduce(
                                (t, v, k) =>
                                    t + (k === 0 ? v.toUpperCase() : v),
                                ''
                            );
                    if (data.isAnalyst) {
                        this.user.perfil = this.$t(
                            'mensagens.menuSuperior.perfil.analista'
                        );
                    } else if (data.isRegular) {
                        this.user.perfil = this.$t(
                            'mensagens.menuSuperior.perfil.cliente'
                        );
                    } else if (data.isAdmin) {
                        this.user.perfil = this.$t(
                            'mensagens.menuSuperior.perfil.administrador'
                        );
                    }

                    this.user.ambienteLogado = data.ambienteLogado;
                    this.empresas.isBrasil = data.isBrasil;
                    this.empresas.isParaguay = data.isParaguay;
                    this.empresas.isArgentina = data.isArgentina;
                    const languageNames = {
                        'pt-BR': 'Português',
                        en: 'English',
                        es: 'Español'
                    };

                    this.selectedLanguageName = languageNames[data.locale];

                    store.dispatch(
                        'updateUsuarioLogadoAmbiente',
                        data.ambienteLogado
                    );

                    if (data.logoUrl) {
                        this.setLogoAplicacao(data);
                    } else {
                        this.logoUrlDefault = true;
                    }
                    // const locale = navigator.language || navigator.userLanguage;

                    // this.switchLanguage(locale);
                })
                .catch(erro => {
                    this.$notify.error({
                        message: this.$t('mensagens.menuSuperior.erro')
                    });
                });
        },
        setLogoAplicacao(data) {
            let logoUrl = null;

            if (this.$i18n._vm.locale === 'en') {
                logoUrl = data.logoUrlIngles;
            }

            if (this.$i18n._vm.locale === 'es') {
                logoUrl = data.logoUrlEspanhol;
            }

            this.logoUrlCustom = logoUrl || data.logoUrl;
        },
        openSupport() {
            window.open(
                'https://vegamonitoramento.atlassian.net/servicedesk/customer/portal/5',
                '_blank'
            );
        }
    },
    watch: {
        '$i18n._vm.locale': function () {
            this.setLogoAplicacao(this.usuarioLogado);
        }
    }
};
</script>

<style lang="scss" scoped>
$width-box-tipo-cultura: 115px;

.link-suporte {
    padding: 8px;
    border-radius: 4px;
    color: var(--primary) !important;
    background: white;
    margin-right: 8px;
    display: flex;
    align-items: center;
    gap: 5px;
    height: 32px;

    span {
        margin-top: 1px;
        font-weight: 600;
        font-size: 14px;
    }

    &__support {
        font-size: 24px;
    }
}

.icon-arrow-lang {
    color: var(--white);
}

#language-dropdown {
    color: var(--white);
    margin-right: 15px;
    margin-left: auto;
    width: auto;
    display: flex;
    align-items: center;
    cursor: pointer;

    span.language-name {
        color: white;
        font-size: 14px;
        margin-right: 4px;
    }
}

#header {
    height: 65px;
    background-color: var(--primary);
    box-shadow: 0px 3px 5px 0px var(--block-shadow);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.el-dropdown-link {
    display: flex;
    align-items: center;
}

.user-logo {
    color: var(--white);
    font-size: 28px;
    margin-right: 5px;
}

.icon-arrow-user {
    color: var(--white);
}

.sair {
    color: var(--primary);
}

#header-monitoramento {
    .flow {
        font-size: 20px;

        &.tilted {
            transform: rotate(45deg);
        }
    }
}

.box {
    display: flex;
    justify-content: center;
    height: 100%;
    min-width: 420px;

    .tipo {
        font-size: map-get($font-size, big);
        height: 100%;

        display: flex;
        justify-content: center;
        align-items: center;

        border-bottom: 2px solid transparent;

        color: var(--white);

        &.active {
            color: var(--secondary);
            border-bottom: 3px solid var(--secondary);

            h6 {
                font-weight: map-get($font-weight, medium);
            }

            i {
                color: var(--secondary);
            }
        }

        i {
            color: var(--disabled-font-color);
        }
    }

    .tipo.cultura {
        width: $width-box-tipo-cultura;
    }

    .tipo.area-monitorada {
        padding: 0 3%;
    }

    &.box-area-monitorada {
        .flow {
            font-size: 26px;
        }
    }
}

#logo-wrapper {
    height: var(--size-logo);
    max-width: 650px;
    clip-path: polygon(0 0, 100% 0%, 95% 100%, 0% 100%);
    margin-left: 51px;

    #logo-lyra {
        max-width: 100%;
    }
}

#logo-wrapper-bunge {
    height: var(--size-logo);
    max-width: 650px;
    margin-left: 30px;

    #logo-bunge {
        max-width: 100%;
        height: var(--size-logo);
    }

    &.logo-be8 {
        margin-left: 14px;
    }
}

.language-code {
    font-size: 11px;
    margin-left: 5px;
    font-weight: bold;
}

#user-logged {
    color: var(--white);
    margin-right: 12px;
    display: flex;
    align-items: center;
    cursor: context-menu;

    span {
        font-size: 14px;
        margin-right: 4px;
    }
}

.action-button {
    cursor: pointer;
}

.dados_user {
    display: flex;
    gap: 5px;
    align-items: center;

    .empresa-selecionada-container {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .username {
        color: var(--white);
        cursor: pointer;
        font-size: 14px;
    }

    .empresa-selecionada {
        width: 25px !important;
        height: 25px !important;
    }
}
</style>
